import React, { useState, useEffect } from "react";
import HallSearchFixedBottomSheet from "./HallSearchFixedBottomSheet";
import SelectMonthSection from "./SelectMonthSection";
import SelectDateSection from "./SelectDateSection";
import Styles from "./selectDateBottomSheet.module.scss";

type Props = {
  tempMonths: string[];
  setTempMonths: (value: React.SetStateAction<string[]>) => void;
  tempDates: { startDate: string; endDate: string };
  setTempDates: (value: React.SetStateAction<{ startDate: string; endDate: string }>) => void;
  isShow: boolean;
  setIsShow: (value: React.SetStateAction<boolean>) => void;
  setIsSelectTimeBottomSheet?: (value: React.SetStateAction<boolean>) => void;
  setIsResetMonthAndDateData?: (value: React.SetStateAction<boolean>) => void;
  setFilterChips?: (prev) => void;
};

export default function SelectDateBottomSheet({
  tempMonths,
  setTempMonths,
  tempDates,
  setTempDates,
  isShow,
  setIsShow,
  setIsSelectTimeBottomSheet,
  setIsResetMonthAndDateData,
  setFilterChips,
}: Props) {
  const [dateTypeTab, setDateTypeTab] = useState<"month" | "date">("month");
  const [selectedMonths, setSelectedMonths] = useState<string[]>([]);
  const [selectedDate, setSelectedDates] = useState<{ startDate: string; endDate: string }>({
    startDate: "",
    endDate: "",
  });

  const formatDate = (dateStr) => {
    const [year, month, day] = dateStr.split("-");
    return `${year}년 ${month}월 ${day}일`;
  };

  const formatMonth = (dateStr) => {
    const [year, month] = dateStr.split("-");
    return `${year}년 ${month}월`;
  };

  const handleTabClick = (tab: "month" | "date") => {
    setDateTypeTab(tab);
  };

  const handleComplete = () => {
    // 시작날짜 하나만 선택한 경우
    if (selectedDate.startDate && !selectedDate.endDate) {
      setTempDates({ startDate: selectedDate.startDate, endDate: selectedDate.startDate });
      setTempMonths([]);
      setIsShow(false);
      setIsSelectTimeBottomSheet && setIsSelectTimeBottomSheet(true);
      setIsResetMonthAndDateData && setIsResetMonthAndDateData(false);

      // setFilterChips이 있는 경우 (상세 > 잔여타임 용)
      if (setFilterChips) {
        const { startDate } = selectedDate;
        setFilterChips((prevChips) => {
          const updatedChip =
            dateTypeTab === "month"
              ? {
                  ...prevChips[1],
                  value: selectedMonths
                    .sort()
                    .map((month) => formatMonth(month))
                    .join(","),
                }
              : { ...prevChips[1], value: `${formatDate(startDate)}~${formatDate(startDate)}` };
          let newChips = prevChips;
          newChips[1] = updatedChip;
          return newChips;
        });
      }
      return;
    }

    setTempDates(selectedDate);
    setTempMonths([...selectedMonths.sort()]);
    setIsShow(false);
    setIsSelectTimeBottomSheet && setIsSelectTimeBottomSheet(true);
    setIsResetMonthAndDateData && setIsResetMonthAndDateData(false);

    if (setFilterChips) {
      const { startDate, endDate } = selectedDate;

      setFilterChips((prevChips) => {
        const updatedChip =
          dateTypeTab === "month"
            ? {
                ...prevChips[1],
                value: selectedMonths
                  .sort()
                  .map((month) => formatMonth(month))
                  .join(","),
              }
            : {
                ...prevChips[1],
                value:
                  !!startDate && !!endDate
                    ? `${formatDate(startDate)}~${formatDate(endDate)}`
                    : null,
              };
        let newChips = prevChips;
        newChips[1] = updatedChip;
        return newChips;
      });
    }
  };
  const handleReset = () => {
    setSelectedMonths([]);
    setSelectedDates({ startDate: "", endDate: "" });
  };

  useEffect(() => {
    // isShow가 false가 되면 선택된 월, 일 초기화
    if (!isShow) {
      setSelectedMonths([]);
      setSelectedDates({ startDate: "", endDate: "" });
    } else {
      setSelectedMonths([...tempMonths]);
      setSelectedDates({ ...tempDates });
    }
  }, [isShow]);
  // 월이 선택되면 상세 날짜 초기화
  useEffect(() => {
    if (selectedMonths.length > 0) {
      setSelectedDates({ startDate: "", endDate: "" });
    }
  }, [selectedMonths]);
  // 상세 날짜가 선택되면 월 초기화
  useEffect(() => {
    if (selectedDate.startDate && selectedDate.endDate) {
      setSelectedMonths([]);
    }
  }, [selectedDate]);

  return (
    <HallSearchFixedBottomSheet
      isShow={isShow}
      title={"날짜를 모두 선택해주세요."}
      isTransition={true}
      hideModal={() => {
        setIsShow(false);
      }}
      style={{ padding: "0", height: "calc(100% - 99px)" }}
    >
      <div className={Styles["tab-wrap"]}>
        <button
          className={dateTypeTab === "month" ? Styles["selected"] : ""}
          onClick={() => handleTabClick("month")}
        >
          월
        </button>
        <button
          className={dateTypeTab === "date" ? Styles["selected"] : ""}
          onClick={() => handleTabClick("date")}
        >
          상세
        </button>
      </div>
      {/* 탭을 이동할때 탭간에 스크롤을 유지시키기위해 즉, 리렌더링을 방지하기 위해 display none 사용 */}
      <div style={dateTypeTab === "date" ? { display: "none" } : {}}>
        <SelectMonthSection
          selectedMonths={selectedMonths}
          setSelectedMonths={setSelectedMonths}
          selectedDate={selectedDate}
          handleComplete={handleComplete}
          handleReset={handleReset}
        />
      </div>
      {/* 탭을 이동할때 탭간에 스크롤을 유지시키기위해 즉, 리렌더링을 방지하기 위해 display none 사용 */}
      <div style={dateTypeTab === "month" ? { display: "none" } : {}}>
        <SelectDateSection
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDates}
          selectedMonths={selectedMonths}
          handleComplete={handleComplete}
          handleReset={handleReset}
        />
      </div>
    </HallSearchFixedBottomSheet>
  );
}
